import Api from 'api'

const config = {
  baseURL: '/api/app/v1/wallets',
}
const api = new Api(config)

api.fetchWallets = () => api.get('')

api.fetchTransactions = ({ id, ...rest }) =>
  api.get(`/${id}/transactions`, { ...rest })

export default api
